import React from 'react'
import LapKeuanganPage from '../../modules/admintbk/LapKeuanganPage'

const LaporanPenjualan = () =>{
  return (
    <LapKeuanganPage></LapKeuanganPage>
    )
}

export default LaporanPenjualan